const addJokeContainer = document.getElementById("add-joke-container");
const jokeContainer = document.getElementById("joke-container");

function goto_addJoke() {
  console.log("fuck this");
  console.log("Loading new page...");
  addJokeContainer.style.display = "block";
  jokeContainer.style.display = "none";
  console.log("Done!");
}

function goto_generator() {
  console.log("Loading joke generator...");
  addJokeContainer.style.display = "none";
  jokeContainer.style.display = "block";
  console.log("Done!");
}

export { goto_addJoke, goto_generator }
